/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  useTheme,
  useMediaQuery,
  Divider,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Button as MUIButton,
  Typography,
  Avatar,
  Menu,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { useState, useEffect } from "react";
import { useThemeContext } from "../../../../context/ThemeContext";
import { useGlobalSettings } from "../../../../context/GlobalSettingsContext";
import {
  formatUdiosCode,
  getRoleData,
  getToken,
  getUserData,
} from "../../../../shared/functions/commonfunction";
import Styles from "../webHeader/WebHeader.module.scss";
import Button from "../../../../shared//button/Button";
import PersonIcon from "@mui/icons-material/Person";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SchoolBuilding from "../../../../assets/images/icons/schoolBuilding.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch } from "react-redux";
import { setToast } from "../../../../shared/store/slice/toastSlice";
import API from "../../../../api/Axios";
import ThemeSwitch from "../../../../shared/themeswitch/ThemeSwitch";

const Navbar = () => {
  const { t } = useTranslation("home");
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileLandscape = useMediaQuery(
    "(orientation: landscape) and (max-height: 600px) and (max-width: 1200px)"
  );
  const isMobile =
    useMediaQuery(theme.breakpoints.down("md")) || isMobileLandscape;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { toggleTheme } = useThemeContext();
  const { language, setLanguage, fontSize, setFontSize, resetFontSize } =
    useGlobalSettings();
  const isDarkMode = theme.palette.mode === "dark";
  const userDetails = getUserData();
  const isLoggedIn = Boolean(getToken());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      const response = await API.post("/um/logout");
      if (response?.status == 200 || response?.statusText == "OK") {
        localStorage.removeItem("data");
        handleClose();
        navigate("/");
        dispatch(
          setToast({
            message: response?.data?.message,
            severity: "success",
            open: true,
          })
        );
      }
    } catch (err) {
      console.log("error facing logout", err);
    }
  };

  const scrollToTimelines = () => {
    if (location.pathname !== "/") {
      navigate("/");
      sessionStorage.setItem("scrollToTimelines", "true");
    } else {
      const timelinesSection = document.getElementById("timelines-section");
      if (timelinesSection) {
        const scrollPosition = timelinesSection.offsetTop - 150;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    }
    setDrawerOpen(false);
  };

  const handleSurveyGuidelines = () => {
    const pdfUrl =
      language === "hi"
        ? `${
            import.meta.env.VITE_API_BASE_URL
          }/static/pdf/guidelines/SHVR_Guidelines_Hindi.pdf`
        : `${
            import.meta.env.VITE_API_BASE_URL
          }/static/pdf/guidelines/SHVR_Guidelines_English.pdf`;
    window.open(pdfUrl, "_blank");
  };

  const roleData = getRoleData();
  const surveySubmitted = getRoleData()?.survey_status == "submitted";
  const isSchoolUser = roleData?.role_code == "SCHOOL_USER";
  const isOtherUser =
    roleData?.role_code == "NATIONAL_NODAL" ||
    roleData?.role_code == "STATE_NODAL" ||
    roleData?.role_code == "DISTRICT_NODAL" ||
    roleData?.role_code == "BOARD_NODAL";

  const isEvaluatorUser =
    roleData?.role_code == "STATE_EVALUATOR" ||
    roleData?.role_code == "DISTRICT_EVALUATOR" ||
    roleData?.role_code == "NATIONAL_EVALUATOR";

  const menuItems = isLoggedIn
    ? [
        {
          title: t("navbar.home"),
          route: "/",
        },
        {
          title: isSchoolUser
            ? t("navbar.schoolDashboard")
            : isOtherUser || isEvaluatorUser
            ? t("navbar.dashboard")
            : t("navbar.schoolDashboard"),
          route: isSchoolUser
            ? "/school-dashboard"
            : isEvaluatorUser
            ? "/evaluator/dashboard"
            : isOtherUser
            ? "/regional-user/dashboard"
            : "/",
        },
        // ...(surveySubmitted
        //   ? [
        //       {
        //         title: t("navbar.certificates"),
        //         route: "/certificates",
        //       },
        //     ]
        //   : []),
        {
          title: t("navbar.about"),
          route: "/about",
        },
        // {
        //   title: t("navbar.guidelines"),
        //   route: "#",
        //   onClick: handleSurveyGuidelines,
        // },
        {
          title: t("navbar.supportResources"),
          route: "/resources",
        },
        {
          title: t("navbar.progress"),
          route: "/progress",
        },
        // {
        //   title: t("navbar.recognizedSchools"),
        //   route: "/recognized-schools-national",
        // },
        {
          title: t("navbar.timelines"),
          route: "#",
          onClick: scrollToTimelines,
        },
        {
          title: t("navbar.faqs"),
          route: "/faqs",
        },
        {
          title: t("navbar.contact"),
          route: "/contact",
        },
      ]
    : [
        {
          title: t("navbar.home"),
          route: "/",
        },
        {
          title: t("navbar.about"),
          route: "/about",
        },
        // {
        //   title: t("navbar.guidelines"),
        //   route: "#",
        //   onClick: handleSurveyGuidelines,
        // },
        {
          title: t("navbar.supportResources"),
          route: "/resources",
        },
        {
          title: t("navbar.progress"),
          route: "/progress",
        },
        // {
        //   title: t("navbar.recognizedSchools"),
        //   route: "/recognized-schools-national",
        // },
        {
          title: t("navbar.timelines"),
          route: "#",
          onClick: scrollToTimelines,
        },
        {
          title: t("navbar.faqs"),
          route: "/faqs",
        },
        {
          title: t("navbar.contact"),
          route: "/contact",
        },
      ];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleNavigation = (route: string) => {
    navigate(route);
    setDrawerOpen(false);
  };

  const handleLanguageChange = (event: SelectChangeEvent) => {
    const newLanguage = event.target.value as string;
    setLanguage(newLanguage);

    // Dispatch custom event to trigger page reload
    const languageChangeEvent = new CustomEvent("languageChange", {
      detail: { language: newLanguage },
    });
    window.dispatchEvent(languageChangeEvent);
  };

  const handleTextSizeChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    switch (value) {
      case "a-":
        setFontSize(0.9);
        break;
      case "a+":
        setFontSize(1.1);
        break;
      default:
        resetFontSize();
        break;
    }
  };

  const languageOptions = [
    { value: "en", label: "Eng" },
    { value: "hi", label: "हिंदी" },
  ];

  const fontOptions = [
    { value: "a-", label: "A-" },
    { value: "a", label: "A" },
    { value: "a+", label: "A+" },
  ];

  const getCurrentFontSize = () => {
    if (fontSize < 1) return "a-";
    if (fontSize > 1) return "a+";
    return "a";
  };

  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const SelectComponent = ({ value, onChange, options = [] }: any) => {
    return (
      <FormControl
        size="small"
        sx={{ width: "100%", mb: 2, borderRadius: "20px" }}
      >
        <Select
          MenuProps={{
            disableScrollLock: true,
            PaperProps: {
              sx: {
                mt: 0.75,
                borderRadius: "20px",
                overflow: "hidden",
              },
            },
          }}
          value={value}
          onChange={onChange}
          variant="outlined"
          fullWidth
          sx={{
            height: 40,
            borderRadius: "20px !important",
            padding: "0 12px",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              padding: "0 !important",
            },
            "& svg": {
              right: 8,
              position: "absolute",
              color: theme.palette.text.primary,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "20px",
              borderColor:
                theme.palette.mode === "light" ? "#1C1E21" : "#ffffff",
              borderWidth: "0.5px !important",
            },
          }}
        >
          {options.map((opt: any) => (
            <MenuItem
              key={opt.value}
              value={opt.value}
              sx={{
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
                "&:hover": {
                  backgroundColor:
                    theme.palette.mode === "light" ? "#f5f5f5" : "#2c2c2c",
                },
              }}
            >
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const CustomThemeSwitch = () => {
    const isDark = theme.palette.mode === "dark";

    return (
      <div className={Styles.drawer_theme_switch}>
        <span className={Styles.theme_label}>
          {isDark ? t("header.dark") : t("header.light")}
        </span>
        <ThemeSwitch
          checked={isDark}
          onChange={() => {
            const newMode = isDark ? "light" : "dark";
            sessionStorage.setItem("theme", newMode);
            toggleTheme();
          }}
        />
      </div>
    );
  };

  const drawer = (
    <Box
      sx={{
        width: { xs: "min(86vw, 340px)", sm: 340 },
        backgroundColor:
          theme.palette.mode === "dark" ? "#142019" : "#F8FBF8",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
      className={Styles.drawer_container}
    >
      <button
        className={Styles.drawer_close_button}
        onClick={handleDrawerToggle}
        aria-label="Close drawer"
      >
        <svg viewBox="0 0 24 24" fill="none">
          <line
            x1="18"
            y1="6"
            x2="6"
            y2="18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="6"
            y1="6"
            x2="18"
            y2="18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>

      <List sx={{ flex: 1, pt: 7, px: 1.5 }}>
        {menuItems.map((item) => {
          const isActive =
            item.route === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.route);
          return (
            <ListItem
              key={item.title}
              sx={{
                py: 0.35,
                px: 0,
              }}
            >
              <MUIButton
                fullWidth
                color="inherit"
                sx={{
                  color: isActive
                    ? theme.palette.mode === "dark"
                      ? "#B7EFBC"
                      : "#106426"
                    : theme.palette.mode === "dark"
                    ? "#F1F5F2"
                    : "#25352B",
                  textTransform: "none",
                  fontSize: `calc(${
                    isLoggedIn ? 14 : 16
                  }px * var(--dynamic-font-size, 1))`,
                  fontWeight: isActive ? "700" : "500",
                  justifyContent: "flex-start",
                  borderRadius: "12px",
                  minHeight: 44,
                  px: "16px !important",
                  transition:
                    "color 0.2s ease, background-color 0.2s ease",
                  backgroundColor: isActive
                    ? theme.palette.mode === "dark"
                      ? "rgba(183, 239, 188, 0.12)"
                      : "rgba(16, 100, 38, 0.09)"
                    : "transparent",
                  "&:hover": {
                    color:
                      theme.palette.mode === "dark" ? "#FFFFFF" : "#18231C",
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.08)"
                        : "#ECEFEC",
                  },
                }}
                onClick={
                  item.onClick
                    ? item.onClick
                    : () => handleNavigation(item.route)
                }
              >
                {item.title}
              </MUIButton>
            </ListItem>
          );
        })}
      </List>

      <Box
        sx={{
          p: 3,
          borderTop: `1px solid ${
            theme.palette.mode === "dark" ? "#304138" : "#DDE6DF"
          }`,
          backgroundColor:
            theme.palette.mode === "dark"
              ? "#101A14 !important"
              : "#F2F7F3 !important",
        }}
      >
        {/* <div className={Styles.drawer_content_button}>
          {t("header.lastUpdated")}
        </div>
        <div
          className={Styles.drawer_content_button}
          onClick={scrollToBenefits}
          style={{ cursor: "pointer" }}
        >
          {t("header.screenReaderAccess")}|{t("header.skipToMain")}
        </div> */}

        <SelectComponent
          value={language}
          onChange={handleLanguageChange}
          options={languageOptions}
        />
        <SelectComponent
          value={getCurrentFontSize()}
          onChange={handleTextSizeChange}
          options={fontOptions}
        />

        <CustomThemeSwitch />

        {!getToken() && (
          <MUIButton
            fullWidth
            variant="contained"
            onClick={() => {
              navigate("/account/login");
              setDrawerOpen(false);
            }}
            sx={{
              backgroundColor: "#106426",
              color: "#fff",
              minHeight: 44,
              borderRadius: "999px",
              fontWeight: 700,
              "&:hover": {
                backgroundColor: "#0B4F1D",
              },
            }}
          >
            {t("header.loginSignup")}
          </MUIButton>
        )}
      </Box>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      sx={{
        background: "transparent",
        boxShadow: "none",
        padding: 0,
      }}
    >
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          px: isMobile ? 1.5 : { md: 3 },
          backgroundColor: "#106426",
          borderRadius: "999px",
          boxShadow: "0 5px 12px rgba(6, 60, 24, 0.18)",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            minHeight: isMobile
              ? "48px !important"
              : { md: "58px !important" },
          }}
        >
          {isMobile ? (
            <>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{
                  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#ffffff",
                  p: 0,
                  margin: 0,
                }}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={handleDrawerToggle}
                sx={{
                  "& .MuiDrawer-paper": {
                    backgroundColor:
                      theme.palette.mode === "dark" ? "#142019" : "#F8FBF8",
                    "&::-webkit-scrollbar": {
                      width: "2px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "transparent",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background:
                        theme.palette.mode === "dark"
                          ? "rgba(183, 239, 188, 0.35)"
                          : "rgba(16, 100, 38, 0.25)",
                      borderRadius: "2px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background:
                        theme.palette.mode === "dark"
                          ? "rgba(183, 239, 188, 0.55)"
                          : "rgba(16, 100, 38, 0.4)",
                    },
                  },
                }}
              >
                {drawer}
              </Drawer>
            </>
          ) : (
            <>
              {/* Menu Items Container */}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {menuItems.map((item) => {
                  const isActive =
                    item.route === "/"
                      ? location.pathname === "/"
                      : location.pathname.startsWith(item.route);
                  return (
                    <MUIButton
                      key={item.title}
                      color="inherit"
                      sx={{
                        color: isActive
                          ? "#FFFFFF"
                          : theme.palette.mode === "dark"
                          ? "#E2E2E2"
                          : "#E2E2E2",
                        textTransform: "none",
                        fontSize: `calc(${
                          menuItems.length > 8 ? 12 : isLoggedIn ? 14 : 16
                        }px * var(--dynamic-font-size, 1))`,
                        mr: { md: 2, lg: 3 },
                        fontWeight: isActive ? "600" : "500",
                        transition: "color 0.3s ease, font-weight 0.3s ease",
                        padding: "0 !important",
                        "&:hover": {
                          color: "#D1D5DB",
                          backgroundColor: "transparent",
                        },
                      }}
                      onClick={
                        item.onClick
                          ? item.onClick
                          : () => handleNavigation(item.route)
                      }
                    >
                      {item.title}
                    </MUIButton>
                  );
                })}
              </Box>
            </>
          )}

          {/* Login Button or Profile Avatar Container - Moved outside mobile/desktop condition */}
          {!getToken() ? (
            <Box sx={{ width: isMobile ? "132px" : "154px" }}>
              <Button
                text={t("header.loginSignup")}
                onClick={() => {
                  navigate("/account/login");
                }}
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: { xs: "14px !important" },
                  height: isMobile
                    ? "36px !important"
                    : "40px !important",
                  backgroundColor: "#fff !important",
                  color: "#143b20 !important",
                  borderRadius: "999px !important",
                  boxShadow: "none !important",
                  transition:
                    "background-color 180ms ease, color 180ms ease !important",
                  "&:hover, &:focus-visible": {
                    backgroundColor: "#e4f8e8 !important",
                    color: "#143b20 !important",
                    boxShadow: "none !important",
                  },
                }}
              />
            </Box>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar
                sx={{
                  bgcolor: isDarkMode ? "#2a2a2a" : "#fff",
                  width: 40,
                  height: 40,
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                <img src={SchoolBuilding} alt="school" />
              </Avatar>
              <Box sx={{ ml: 1, textAlign: "left" }}>
                <Typography
                  sx={{
                    color: "#fff",
                    fontWeight: 500,
                    fontSize: `calc(16px * var(--dynamic-font-size, 1))`,
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "120px",
                  }}
                >
                  {userDetails?.name || "NA"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 !important",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#fff",
                      fontWeight: 400,
                      fontSize: `calc(13px * var(--dynamic-font-size, 1))`,
                      opacity: 0.8,
                      lineHeight: 1,
                      mb: 0,
                    }}
                  >
                    {isOtherUser || isEvaluatorUser
                      ? userDetails?.role?.role_name
                      : formatUdiosCode(userDetails?.role?.school_udise_code)}
                  </Typography>
                  {!(
                    userDetails?.role?.role_code === "STATE_NODAL" ||
                    userDetails?.role?.role_code === "DISTRICT_NODAL"
                  ) && (
                    <IconButton
                      sx={{ color: "#fff", padding: "0 !important", ml: 0.5 }}
                      onClick={handleProfileClick}
                      aria-controls={open ? "profile-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    >
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </Box>
                {(userDetails?.role?.role_code === "STATE_NODAL" ||
                  userDetails?.role?.role_code === "DISTRICT_NODAL") && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 !important",
                      mt: 0,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#fff",
                        fontWeight: 400,
                        fontSize: `calc(12px * var(--dynamic-font-size, 1))`,
                        opacity: 0.7,
                        lineHeight: "1 !important",
                        mt: 0,
                      }}
                    >
                      {userDetails?.role?.role_code === "STATE_NODAL" &&
                        (userDetails?.role?.state_name || "NA")}
                      {userDetails?.role?.role_code === "DISTRICT_NODAL" &&
                        (userDetails?.role?.district_name || "NA")}
                    </Typography>
                    <IconButton
                      sx={{
                        color: "#fff",
                        padding: "0 !important",
                        ml: 0.5,
                        height: "0.8em",
                      }}
                      onClick={handleProfileClick}
                      aria-controls={open ? "profile-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    >
                      <ArrowDropDownIcon />
                    </IconButton>
                  </Box>
                )}
              </Box>

              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                disableScrollLock
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                sx={{
                  mt: 1.5,
                  minWidth: 250,
                  borderRadius: "12px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  "& .MuiPaper-root": {
                    borderRadius: "12px",
                    backgroundColor: isDarkMode ? "#1f1f1f" : "#ffffff",
                    color: isDarkMode ? "#e0e0e0" : "#333",
                  },
                }}
              >
                {!isOtherUser && (
                  <MenuItem
                    onClick={() => navigate("/school-dashboard/profile")}
                    sx={{
                      fontSize: `calc(15px * var(--dynamic-font-size, 1))`,
                      fontWeight: 500,
                      px: 2,
                      py: 1.5,
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      borderRadius: "8px",
                      transition: "background-color 0.2s",
                      "&:hover": {
                        backgroundColor: isDarkMode ? "#2a2a2a" : "#f0f0f0",
                      },
                    }}
                  >
                    <PersonIcon fontSize="small" />
                    {t("navbar.profile")}
                  </MenuItem>
                )}

                <MenuItem
                  onClick={handleLogout}
                  sx={{
                    fontSize: `calc(15px * var(--dynamic-font-size, 1))`,
                    fontWeight: 500,
                    px: 2,
                    py: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    borderRadius: "8px",
                    transition: "background-color 0.2s",
                    "&:hover": {
                      backgroundColor: isDarkMode ? "#2a2a2a" : "#f0f0f0",
                    },
                  }}
                >
                  <ExitToAppIcon fontSize="small" />
                  {t("navbar.logout")}
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
